"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunitySessionCreateDto = instanceOfOrientationOpportunitySessionCreateDto;
exports.OrientationOpportunitySessionCreateDtoFromJSON = OrientationOpportunitySessionCreateDtoFromJSON;
exports.OrientationOpportunitySessionCreateDtoFromJSONTyped = OrientationOpportunitySessionCreateDtoFromJSONTyped;
exports.OrientationOpportunitySessionCreateDtoToJSON = OrientationOpportunitySessionCreateDtoToJSON;
exports.OrientationOpportunitySessionCreateDtoToJSONTyped = OrientationOpportunitySessionCreateDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunitySessionCreateDto interface.
 */
function instanceOfOrientationOpportunitySessionCreateDto(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('isDateTimeNegotiable' in value) || value['isDateTimeNegotiable'] === undefined)
        return false;
    return true;
}
function OrientationOpportunitySessionCreateDtoFromJSON(json) {
    return OrientationOpportunitySessionCreateDtoFromJSONTyped(json, false);
}
function OrientationOpportunitySessionCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'isDateTimeNegotiable': json['isDateTimeNegotiable'],
    };
}
function OrientationOpportunitySessionCreateDtoToJSON(json) {
    return OrientationOpportunitySessionCreateDtoToJSONTyped(json, false);
}
function OrientationOpportunitySessionCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'isDateTimeNegotiable': value['isDateTimeNegotiable'],
    };
}
//# sourceMappingURL=OrientationOpportunitySessionCreateDto.js.map